import { render, staticRenderFns } from "./WhatsAppContactCards.vue?vue&type=template&id=28eefc96&scoped=true&"
import script from "./WhatsAppContactCards.vue?vue&type=script&lang=js&"
export * from "./WhatsAppContactCards.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppContactCards.vue?vue&type=style&index=0&id=28eefc96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eefc96",
  null
  
)

export default component.exports